exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ruleForm[data-v-714c8e08] {\n  padding: 0 48px 24px;\n}\n", ""]);

// exports
